import { Component, Input, ViewChildren } from '@angular/core';

import { isDesktop } from 'rev-shared/util/UserAgentUtil';
import { VideoStatus } from 'rev-shared/media/VideoStatus';
import { VideoSourceType } from 'rev-shared/media/VideoSourceType';
import { VbConfirmationDialogComponent } from 'rev-shared/ui/dialog/VbConfirmationDialogAngular.Component';
import { ITranscodeInitiator, TranscodeInitiatorType } from 'rev-shared/media/TranscodeInitiatorType';

import { VideoPlaybackService } from './VideoPlayback.Service';

import styles from './video-download.module.less';

@Component({
	selector: 'video-download',
	templateUrl: './VideoDownload.Component.html'
})
export class VideoDownloadComponent {
	@Input() private enableDownloads: boolean;
	@Input() private video: any;
	@ViewChildren(VbConfirmationDialogComponent) public downloadErrorDialog: VbConfirmationDialogComponent;

	public readonly styles = styles;
	public desktopUserAgent: boolean;

	constructor(
		private VideoPlaybackSvc: VideoPlaybackService
	) {
		this.desktopUserAgent = isDesktop();
	}

	public get videoAvailableForDownload(): boolean {
		return this.isDownloadEnabled
			&& this.video.downloadUrl
			&& this.isVideoReady;
	}

	public get videoNotAvailableForDownload(): boolean {
		return this.isDownloadEnabled
			&& (!this.video.downloadUrl
				&& this.validateVideoSource()
				|| !this.isVideoReady
			);
	}

	public get videoNotPreparedForDownload(): boolean {
		return this.validateVideoConferenceState()
			&& !this.video.transcodeOnDemandInitiator;
	}

	public get videoPreparingForDownload(): boolean {
		return this.validateVideoConferenceState()
			&& this.video.transcodeOnDemandInitiator;

	}

	private validateVideoConferenceState(): boolean {
		return this.isDownloadEnabled
			&& !this.video.downloadUrl
			&& this.isVideoReady
			&& !this.isVideoConferenceTranscodeFailed;
	}

	private validateVideoSource(): boolean {
		return !this.isVideoConferenceSource || this.isVideoConferenceTranscodeFailed;
	}

	private get isDownloadEnabled(): boolean {
		return this.enableDownloads
			&& this.video.downloadingEnabled
			&& !this.video.legalHold;
	}

	private isVideoConferenceSource(): boolean {
		return this.video.sourceType === VideoSourceType.VIDEO_CONFERENCE
			|| this.video.sourceType === VideoSourceType.WEBRTC_RECORDING
			|| this.video.sourceType === VideoSourceType.WEBRTC_SINGLE_PRESENTER;
	}

	private get isVideoConferenceTranscodeFailed(): boolean {
		return this.isVideoConferenceSource && this.video.transcodeFailed;
	}

	private get isVideoReady(): boolean {
		return this.video.status === VideoStatus.READY || this.video.status === VideoStatus.READY_BUT_PROCESSING_FAILED;
	}

	public transcodeVideoForDownload(): void {
		const initiator: ITranscodeInitiator = {
			type: TranscodeInitiatorType.DOWNLOAD,
		};
		this.VideoPlaybackSvc.transcodeVideoForDownload(this.video.id, initiator)
			.subscribe(
				downloadUrl => {
					if (downloadUrl) {
						window.location = downloadUrl;
					}
				},
				() => this.showTranscodingForDownloadErrorPopup()
			);
	}

	public downloadVideo(): void {
		if (!this.video.downloadUrl) {
			return;
		}
		this.VideoPlaybackSvc.setVideoDownload(this.video.id, this.video.downloadUrl);
	}

	private showTranscodingForDownloadErrorPopup(): void {
		this.downloadErrorDialog.open().result
			.then(() => {
				this.VideoPlaybackSvc.clearTranscodeError(this.video.id);
			});
	}

}
